/**
 * Blog Posts Slider with Auto-scroll
 */

(function() {
  'use strict';

  function initBlogSlider() {
    // Check if jQuery and Slick are available
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      console.error('jQuery or Slick Slider not loaded');
      return;
    }

    const sliderElements = document.querySelectorAll('[data-blogs-posts-slider]');

    sliderElements.forEach((slider) => {
      const sliderContainer = slider.closest('.blog-posts-slider');
      if (!sliderContainer) return;

      const sectionId = sliderContainer.id.replace('blog-posts-slider-', '');
      const enableArrows = slider.dataset.arrows === 'true';
      const enableDots = slider.dataset.dots === 'true';
      const enableAutoScroll = slider.dataset.autoscroll === 'true';
      const autoScrollInterval = parseInt(slider.dataset.autoscrollInterval) || 5000;

      // Check if slick is already initialized
      if (jQuery(slider).hasClass('slick-initialized')) {
        return;
      }

      // Initialize Slick Slider
      const $slider = jQuery(slider);

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: enableArrows,
        dots: enableDots,
        infinite: true,
        autoplay: enableAutoScroll,
        autoplaySpeed: autoScrollInterval,
        speed: 600,
        cssEase: 'ease-in-out',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous article"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next article"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      });

      if (window.AGFNA11y) {
        window.AGFNA11y.normalizeSlick(slider, 'Latest articles');
      }

      $slider.on('afterChange.agfnA11y', function() {
        if (window.AGFNA11y) {
          window.AGFNA11y.normalizeSlick(slider, 'Latest articles');
        }
      });

      // Pause autoplay on hover if autoscroll is enabled
      if (enableAutoScroll) {
        jQuery(slider).on('mouseenter', function() {
          jQuery(this).slick('slickPause');
        }).on('mouseleave', function() {
          jQuery(this).slick('slickPlay');
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogSlider);
  } else {
    initBlogSlider();
  }

  // Re-initialize on section reload (Shopify theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      setTimeout(initBlogSlider, 100);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      const slider = event.target.querySelector('[data-blogs-posts-slider]');
      if (slider && jQuery(slider).hasClass('slick-initialized')) {
        jQuery(slider).slick('unslick');
      }
    });
  }
})();
